import { useEffect, useState } from "react";
import { Button, Switch } from "antd";
import { useRouter } from "next/router";
import useAuth from "@/hooks/useAuth";
import { updateProfile, useGetUserProfile } from "@/hooks/useUsers";
import { PAGE_URL } from "@/utils/constants";
import { IAuth } from "@/types";
import useEnvironmentStore, { setEnvUsecase, setModuleUsecase } from "@/store/useEnvironmentStore";
import useAuthStore from "@/store/useAuthStore";

const DevDebugTools = () => {
  const {user} = useAuthStore();
  const router = useRouter();
  const userId = user?.bio?.userId || "";

  const {refetch: refetchDataUser } = useGetUserProfile(userId, true);

  const { env, module } = useEnvironmentStore();

  const [isOpen, isOpenSet] = useState(false);
  const [isLoading, isLoadingSet] = useState({
    resetOnboarding: false,
    finishOnboarding: false,
  });

  function setLoadingState(key: string, value: any) {
    isLoadingSet((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("keydown", (e) => {
        if (e.ctrlKey && e.key === "6") {
          window.addEventListener(
            "keydown",
            (e2) => {
              if (e2.key === ";") {
                isOpenSet((prev) => !prev);
              }
            },
            { once: true },
          );
        }
      });
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      refetchDataUser();
    }
  }, [isOpen]);

  // const isOnboarded = dataUser?.user?.isOnboarded;
  const _version = user?.bio?.user?._version;

  if (!isOpen) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[99999] bg-white rounded-lg shadow-md w-full max-w-xs h-[15em] p-4 overflow-auto">
      <h1 className="text-xl font-bold mb-4 !text-black">Dev Debug Tools</h1>
      <div className="grid grid-cols-2 gap-4">
        <Button
          type="primary"
          block
          loading={isLoading?.resetOnboarding}
          onClick={async () => {
            setLoadingState("resetOnboarding", true);
            await updateProfile({
              id: userId,
              _version: _version,
              isOnboarded: false,
            });
            setLoadingState("resetOnboarding", false);
            if (router.pathname !== PAGE_URL.dashboard) {
              router.replace(PAGE_URL.dashboard);
            } else {
              router.reload();
            }
          }}
        >
          <span className="text-xs">Reset Onboarding</span>
        </Button>
        <Button
          type="primary"
          block
          loading={isLoading?.finishOnboarding}
          onClick={async () => {
            setLoadingState("finishOnboarding", true);
            await updateProfile({
              id: userId,
              _version: _version,
              isOnboarded: true,
            });
            window.localStorage.removeItem("onboard-step");
            window.localStorage.removeItem("use-import-linkedin");
            document.body.style.removeProperty("overflow");
            setLoadingState("finishOnboarding", false);
            if (router.pathname !== PAGE_URL.dashboard) {
              router.replace(PAGE_URL.dashboard);
            } else {
              router.reload();
            }
          }}
        >
          <span className="text-xs">Finish Onboarding</span>
        </Button>

        <div className="grid grid-cols-2 gap-1">
          <div className="text-xs flex flex-col">
            <Switch
              size="small"
              checked={env === "ml"}
              onChange={(e) => setEnvUsecase(e ? "ml" : "dev")}
              style={{ backgroundColor: env === "ml" ? "#4F46E5" : "#E5E7EB" }}
            />
            Milken mode
          </div>
          <div className="text-xs flex flex-col">
            <Switch
              size="small"
              checked={env === "stg"}
              onChange={(e) => setEnvUsecase(e ? "stg" : "dev")}
              style={{ backgroundColor: env === "stg" ? "#4F46E5" : "#E5E7EB" }}
            />
            Staging mode
          </div>
          <div className="text-xs flex flex-col">
            <Switch
              size="small"
              checked={env === "hbas"}
              onChange={(e) => setEnvUsecase(e ? "hbas" : "dev")}
              style={{
                backgroundColor: env === "hbas" ? "#4F46E5" : "#E5E7EB",
              }}
            />
            HBAS mode
          </div>
          <div className="text-xs flex flex-col">
            <Switch
              size="small"
              checked={env === "hbaw"}
              onChange={(e) => setEnvUsecase(e ? "hbaw" : "dev")}
              style={{
                backgroundColor: env === "hbaw" ? "#4F46E5" : "#E5E7EB",
              }}
            />
            HBAW mode
          </div>
        </div>
        <div className="text-xs flex flex-col gap-2">
          <div className="flex flex-col">
            <label className="font-bold gap-1" htmlFor="module">Module</label>
            <select
              className="bg-gray-100 p-1"
              onChange={(e) =>
                setModuleUsecase(
                  (e?.target?.value as "conference" | "organization") || module
                )
              }
              value={module}
              name="module"
              id="module"
            >
              <option value="conference">Conference</option>
              <option value="organization">Organization</option>
            </select>
          </div>
          {/* Uncomment to have select option for package type
          <div className="flex flex-col gap-1">
            <label className="font-bold" htmlFor="packageType">Package Type</label>
            <select className="bg-gray-100 p-1" onChange={(e) => setPackageType(
              (e?.target?.value as "basic" | "premium") || packageType
            )} value={packageType} name="packageType" id="packageType">
              <option value="basic">Basic</option>
              <option value="premium">Premium</option>
            </select>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default DevDebugTools;
